export default __webpack_public_path__ + "static/media/phone.ad13084e.svg";